import { render, staticRenderFns } from "./commodityClassify.vue?vue&type=template&id=129049c9&scoped=true&"
import script from "./commodityClassify.vue?vue&type=script&lang=js&"
export * from "./commodityClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129049c9",
  null
  
)

export default component.exports